export default "And finally there are generative AI programs that can give you full *video*\n"